import { render, staticRenderFns } from "./MdDualListBox.vue?vue&type=template&id=b9244652&"
import script from "./MdDualListBox.vue?vue&type=script&lang=js&"
export * from "./MdDualListBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports